var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 151h-45v346c0 8.284 6.716 15 15 15h30 30c8.284 0 15-6.716 15-15v-346z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301 497v-346h-45v361h30c8.284 0 15-6.716 15-15z",
    fill: "#7e325f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 241h-150-151c-3.984 0-7.793 1.582-10.605 4.395l-90 90c-5.859 5.859-5.859 15.352 0 21.211l90 90c2.812 2.812 6.621 4.394 10.605 4.394h151 150c8.291 0 15-6.709 15-15v-180c0-8.291-6.709-15-15-15z",
    fill: "#ff6e7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421 436v-180c0-8.291-6.709-15-15-15h-150v210h150c8.291 0 15-6.709 15-15z",
    fill: "#ff468c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.605 95.395-90-91c-2.812-2.813-6.621-4.395-10.605-4.395h-151-150c-8.291 0-15 6.709-15 15v181c0 8.291 6.709 15 15 15h150 151c3.984 0 7.793-1.582 10.605-4.395l90-90c5.86-5.859 5.86-15.351 0-21.21z",
    fill: "#b4eb91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.605 206.605 90-90c5.859-5.859 5.859-15.352 0-21.211l-90-91c-2.812-2.812-6.621-4.394-10.605-4.394h-151v211h151c3.984 0 7.793-1.582 10.605-4.395z",
    fill: "#96d778"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m335.395 146.605-30-30c-5.859-5.859-5.859-15.352 0-21.211s15.352-5.859 21.211 0l17.476 17.476 27.217-38.086c4.834-6.738 14.209-8.276 20.918-3.486 6.738 4.805 8.306 14.18 3.486 20.918l-37.5 52.5c-5.418 7.584-16.285 8.413-22.808 1.889z",
    fill: "#b5efff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m187.211 346 10.605-10.605c5.859-5.859 5.859-15.352 0-21.211s-15.352-5.859-21.211 0l-10.605 10.605-10.605-10.605c-5.859-5.859-15.352-5.859-21.211 0s-5.859 15.352 0 21.211l10.605 10.605-10.605 10.605c-5.859 5.859-5.859 15.352 0 21.211s15.351 5.86 21.211 0l10.605-10.605 10.605 10.605c5.859 5.859 15.351 5.86 21.211 0 5.859-5.859 5.859-15.352 0-21.211z",
    fill: "#e3fbff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecision);
export default __webpack_public_path__ + "static/media/decision.8ab33377.svg";
export { ForwardRef as ReactComponent };